// extracted by mini-css-extract-plugin
export var label = "_fu-2";
export var slideContainer = "_fu-0";
export var slider = "_fu-1";